var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-list"},_vm._l((_vm.tags),function(tag){return _c('tag-list-chip',{key:tag.id,attrs:{"selectedTagIds":_vm.selectedTagIds,"tag":tag},on:{"select-tag":_vm.selectTag}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }